import * as React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import { getOnboardingType, getOnboardingSteps } from "../../OnboardingNUX.util";

// util
import { track, TrackingEvents } from "@util/analytics.util";

// internal
import { IProps, IState, PillConfiguration } from "./OnboardingSplitScreenStep.d";
import { styles } from "./OnboardingSplitScreenStep.styles";

class OnboardingSplitScreenStepComponent extends React.Component<IProps, IState> {
  private goTo = (pill: PillConfiguration) => () => {
    const onboardingType = getOnboardingType(this.props.onboardingMeta);
    const steps = getOnboardingSteps(onboardingType);

    if (
      pill.step === this.props.currentStep ||
      (this.props.lockedStepMap && this.props.lockedStepMap[pill.step]) ||
      (this.props.hasErrors &&
        this.props.currentStep &&
        steps.indexOf(this.props.currentStep) < steps.indexOf(pill.step))
    ) {
      return;
    }

    track(TrackingEvents.ONBOARDING.ONBOARDING_PILL_CLICKED, {
      label: pill.label,
      step: pill.step,
    });

    if (this.props.goTo) {
      this.props.goTo(pill.step);
    }
  };

  public render() {
    const {
      children,
      classes,
      displayPaneClassName,
      configurationPaneChildren,
      configurationPaneClassName,
      currentStep,
      onboardingMeta,
      pills,
      lockedStepMap,
      displayPaneStyleOverride,
    } = this.props;

    const onboardingType = getOnboardingType(onboardingMeta);
    const steps = getOnboardingSteps(onboardingType);

    return (
      <React.Fragment>
        <div
          className={`${classes.configurationPane}${
            configurationPaneClassName ? ` ${configurationPaneClassName}` : ""
          }`}
        >
          {pills && pills.length ? (
            <div className={classes.stepPill}>
              <div className="pill-container">
                {pills.map((pill) => {
                  const isDisabled =
                    (lockedStepMap && lockedStepMap[pill.step]) ||
                    (this.props.hasErrors &&
                      this.props.currentStep &&
                      steps.indexOf(this.props.currentStep) < steps.indexOf(pill.step));

                  return (
                    <div
                      key={pill.step}
                      onClick={this.goTo(pill)}
                      className={`pill${
                        currentStep === pill.step ? " active" : isDisabled ? " disabled" : ""
                      }`}
                    >
                      {pill.label}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
          {configurationPaneChildren ? configurationPaneChildren : null}
        </div>
        <div
          className={`${classes.displayPane}${
            displayPaneClassName ? ` ${displayPaneClassName}` : ""
          }`}
          style={displayPaneStyleOverride}
        >
          {children}
        </div>
      </React.Fragment>
    );
  }
}

export const OnboardingSplitScreenStep = withStyles(styles)(OnboardingSplitScreenStepComponent);
